export default __webpack_public_path__ + "static/media/location--1.5d8079b3.jpg";